import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { Drawer } from "@/shared/ui/drawer";

interface PayloadDrawerProps {
  /** GET /v1/orders/{id}/raw's body, via useRawPayload — undefined while loading/closed. */
  raw: unknown;
  open: boolean;
  onClose: () => void;
}

/**
 * Renders the order's raw marketplace payload (GET .../raw), opened from the
 * "View marketplace payload" link at the bottom of the activity feed.
 * Text-only (JSON.stringify → <pre>), never dangerouslySetInnerHTML.
 */
export function PayloadDrawer({ raw, open, onClose }: PayloadDrawerProps): JSX.Element {
  const { t } = useTranslation("orders");

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={t("pd_title")}
      width={540}
      data-testid="payload-drawer"
    >
      <div className="px-5 py-4">
        <pre
          data-testid="payload-drawer-json"
          className="overflow-x-auto rounded-lg bg-[var(--surface-sunken)] p-4 font-mono text-xs leading-relaxed text-[var(--text-primary)]"
        >
          {raw !== undefined ? JSON.stringify(raw, null, 2) : ""}
        </pre>
      </div>
    </Drawer>
  );
}
